import Node from 'ln/node/Node';
import Lang from 'ln/lang/Lang';
import PauseModel from '../models/PauseModel';
import CourseElement from './CourseElement';
import Course from "./Course";

class Pause extends CourseElement {

	constructor( public model: PauseModel, private courseView: Course ) {
		super( model, courseView );
	}
	
	public init() {
		super.init();
		
		// listen for changes
		this.node.js( 'title' ).change.add( this.onTitleChange, this );
		this.node.js( 'time' ).change.add( this.onTimeChange, this );

		this.renderDisplayTime();
	}
	
	private onTitleChange( n:Node ){
		this.model.title = n.value;
		this.model.save();
	}
	
	private onTimeChange( n:Node ){
		this.model.time = parseInt( n.value );
		this.model.save();
		
		// update round time button
		this.node.one( '.timeline-button' ).html = n.value + '\'';

		// update the course header
		this.courseView.rerenderComputedProperties();
		
		this.model.course.rerenderDisplayTime.dispatch();
	}

	protected renderDisplayTime() {
		this.node.one('.display-time').html = this.model.displayTime + ' ' + Lang.translate( 'processplan.time' );
	}
}

export default Pause;


